<template>
    <div class="row boxs--wrapper"
         v-if="isActiveForPastAndToday(event.Services.Certificate) || isPica || isActiveAndInThePast(event.Services.Video)">
        <div class="col-12">
            <div class="row boxs--wrapper">
                <div class="col" v-if="isActiveForPastAndToday(event.Services.Certificate) || (isAvailable(event.Services.Certificate) && admin)">
                    <div class="certified-box--wrapper">
                        <div class="certified-box--wrapper--header">
                            <img src="../assets/svg/certified.svg" height="50" alt="">
                            <div class="certified-box--wrapper--header--hgroup">
                                <div class="certified-box--wrapper--header--hgroup--eyebrow">{{$t('boxs_wrapper.certificate.title')}}</div>
                                <div class="certified-box--wrapper--header--hgroup--title">{{data.Description}}</div>
                            </div>
                        </div>
                        <a class="certified-box--wrapper--cta" v-if="atl" @click="downloadCertificate()">{{$t('boxs_wrapper.certificate.cta')}}</a>
                        <div class="certified-box--wrapper--txt" v-else>{{$t('boxs_wrapper.certificate.available')}}</div>
                    </div>
                </div>

                <div class="col" v-if="isPica">
                    <div class="getpica-box--wrapper">
                        <div>
                            <div class="getpica-box--wrapper--header">
                                <img :src="data.Services.PhotoIcon" height="50" alt="">
                                <div class="getpica-box--wrapper--txt mt-2">
                                    <span v-if="isComing(data.Services.Photo)">{{$t('boxs_wrapper.getpica.coming_soon')}}</span>
                                    <span v-if="isActiveAndInThePast(data.Services.Photo)">{{$t('boxs_wrapper.getpica.available')}}</span>
                                </div>
                            </div>
                            <a v-if="isActiveAndInThePast(event.Services.Photo)" class="getpica-box--wrapper--cta"
                               href="https://www.getpica.com" target="_blank">
                                <span class="getpica-box--wrapper--cta--text">{{$t('boxs_wrapper.getpica.cta')}}</span>
                                <img class="ml-2" src="../assets/svg/ext-link-arrow-light.svg" height="8" alt="">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col" v-if="isActiveAndInThePast(event.Services.Video)">
                    <div class="video-box--wrapper">
                        <div>
                            <div class="video-box--wrapper--header">
                                <!--<img :src=data.Services.VideoIcon height="40" alt="">-->
                                <img src="../assets/svg/service-video.svg" height="60" alt="">
                                <div class="video-box--wrapper--txt">
                                    <span>{{$t('boxs_wrapper.video.coming_soon')}}</span>
                                    <!--<span>{{$t('boxs_wrapper.getpica.available')}}</span>-->
                                </div>
                            </div>
                            <a class="video-box--wrapper--cta" :href="event.Services.VideoUrl" target="_blank">
                                <span class="video-box--wrapper--cta--text">{{$t('boxs_wrapper.getpica.cta')}}</span>
                                <img class="ml-2" src="../assets/svg/ext-link-arrow-light.svg" height="8" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DownloadCertificate ref="cert"></DownloadCertificate>
    </div>
</template>

<script>
    import BaseVue from '../views/BaseVue'
    import DownloadCertificate from './DownloadCertificate'

    export default {
        name: 'BoxServizi',
        components: {DownloadCertificate},
        props: ['data', 'atl','event','ranking'],
        extends: BaseVue,
        methods: {
            downloadCertificate() {
                this.$refs.cert.download(this.data,this.event,this.atl,this.ranking.id)
            }
        }, computed: {
            isPica() {
                if (!this.data || !this.data.Services)
                    return false
                return (this.data.Services.PhotoUrl === 'https://www.getpica.com')
            }
        }
    }
</script>
